import { render, staticRenderFns } from "./departmentSelect.vue?vue&type=template&id=b88a00b8&scoped=true&"
import script from "./departmentSelect.vue?vue&type=script&lang=js&"
export * from "./departmentSelect.vue?vue&type=script&lang=js&"
import style0 from "./departmentSelect.vue?vue&type=style&index=0&id=b88a00b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88a00b8",
  null
  
)

export default component.exports